module.exports = __webpack_public_path__ + "fonts/SF-Pro-Display-Black.53fdc561.ttf";